import { Logo } from '@/components/atoms/Logo'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
  useSidebar,
} from '@/components/ui/sidebar'
import { useAppSelector } from '@/store/hooks'
import { Car, ClipboardCheck, Database, FileText, FolderKanban } from 'lucide-react'
import { NavLink } from 'react-router-dom'

const navItems = [
  { title: 'Delcheck', url: '/cases', icon: FolderKanban },
  { title: 'Kalkylgranskaren', url: '/estimate-feedback', icon: ClipboardCheck },
  { title: 'Fakturor', url: '/invoices', icon: FileText },
  { title: 'Bilar', url: '/cars', icon: Car },
]

const adminNavItems = [{ title: 'Cabas Sync', url: '/cabas-sync', icon: Database }]

export const AppSidebar = () => {
  const { state } = useSidebar()
  const collapsed = state === 'collapsed'
  const { user } = useAppSelector(state => state.auth)
  const isAdmin = user?.roles?.includes('admin') ?? false

  return (
    <Sidebar collapsible="icon" className="z-20">
      <SidebarContent>
        <div className="p-4 border-b border-sidebar-border">{!collapsed && <Logo />}</div>

        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map(item => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      className={({ isActive }) => (isActive ? 'bg-sidebar-accent text-sidebar-accent-foreground' : '')}
                    >
                      <item.icon className="h-4 w-4" />
                      {!collapsed && <span>{item.title}</span>}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        {isAdmin && (
          <>
            <SidebarSeparator />
            <SidebarGroup>
              <SidebarGroupLabel>Admin</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {adminNavItems.map(item => (
                    <SidebarMenuItem key={item.title}>
                      <SidebarMenuButton asChild>
                        <NavLink
                          to={item.url}
                          className={({ isActive }) =>
                            isActive ? 'bg-sidebar-accent text-sidebar-accent-foreground' : ''
                          }
                        >
                          <item.icon className="h-4 w-4" />
                          {!collapsed && <span>{item.title}</span>}
                        </NavLink>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </>
        )}
      </SidebarContent>
    </Sidebar>
  )
}
